import React, { useState } from 'react';
import { useParent } from '../../context/ParentContext';
import { FiX } from 'react-icons/fi';
import './AddStudentModal.css';

function AddStudentModal({ onClose }) {
  const { inviteChild } = useParent();
  const [activeTab, setActiveTab] = useState('connect');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  // Connect existing student form
  const [connectEmail, setConnectEmail] = useState('');
  const [connectCode, setConnectCode] = useState('');

  // Create profile form
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [grade, setGrade] = useState('');
  const [school, setSchool] = useState('');
  const [graduationYear, setGraduationYear] = useState('');

  const sendInvite = async ({ email: inviteEmail, firstName: fn, lastName: ln }) => {
    setBusy(true);
    setError('');
    try {
      await inviteChild({ email: inviteEmail, firstName: fn, lastName: ln });
      setSubmitted(true);
    } catch (err) {
      setError(err?.message || 'Could not send the invite. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  const handleConnect = (e) => {
    e.preventDefault();
    sendInvite({ email: connectEmail });
  };

  const handleCreate = (e) => {
    e.preventDefault();
    sendInvite({ email, firstName, lastName });
  };

  return (
    <div className="add-student-modal__overlay" onClick={onClose} role="dialog" aria-modal="true" aria-label="Add Student">
      <div className="add-student-modal" onClick={e => e.stopPropagation()}>
        <div className="add-student-modal__header">
          <h2>Add a Student</h2>
          <button className="add-student-modal__close" onClick={onClose} aria-label="Close">
            <FiX size={20} />
          </button>
        </div>

        {submitted ? (
          <div className="add-student-modal__success">
            <div className="add-student-modal__success-icon">✓</div>
            <h3>Invite sent</h3>
            <p>We emailed an invite to your child. Once they accept, they'll appear in your Parent Portal.</p>
            <button className="add-student-modal__done-btn" onClick={onClose}>Done</button>
          </div>
        ) : (
          <>
          {error && <div className="add-student-modal__error" role="alert">{error}</div>}
            <div className="add-student-modal__tabs">
              <button
                className={`add-student-modal__tab ${activeTab === 'connect' ? 'add-student-modal__tab--active' : ''}`}
                onClick={() => setActiveTab('connect')}
              >
                Connect Existing Student
              </button>
              <button
                className={`add-student-modal__tab ${activeTab === 'create' ? 'add-student-modal__tab--active' : ''}`}
                onClick={() => setActiveTab('create')}
              >
                Create Student Profile
              </button>
            </div>

            {activeTab === 'connect' ? (
              <form onSubmit={handleConnect} className="add-student-modal__form">
                <div className="add-student-modal__field">
                  <label htmlFor="connect-email">Student Email</label>
                  <input id="connect-email" type="email" value={connectEmail} onChange={e => setConnectEmail(e.target.value)} placeholder="student@school.edu" required />
                </div>
                <div className="add-student-modal__field">
                  <label htmlFor="connect-code">Connection Code (optional)</label>
                  <input id="connect-code" type="text" value={connectCode} onChange={e => setConnectCode(e.target.value)} placeholder="Enter code from student" />
                </div>
                <button type="submit" className="add-student-modal__submit" disabled={!connectEmail || busy}>
                  {busy ? 'Sending…' : 'Send Invite'}
                </button>
              </form>
            ) : (
              <form onSubmit={handleCreate} className="add-student-modal__form">
                <div className="add-student-modal__row">
                  <div className="add-student-modal__field">
                    <label htmlFor="create-first">First Name</label>
                    <input id="create-first" type="text" value={firstName} onChange={e => setFirstName(e.target.value)} required />
                  </div>
                  <div className="add-student-modal__field">
                    <label htmlFor="create-last">Last Name</label>
                    <input id="create-last" type="text" value={lastName} onChange={e => setLastName(e.target.value)} required />
                  </div>
                </div>
                <div className="add-student-modal__field">
                  <label htmlFor="create-email">Email</label>
                  <input id="create-email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="student@school.edu" required />
                </div>
                <div className="add-student-modal__row">
                  <div className="add-student-modal__field">
                    <label htmlFor="create-grade">Grade</label>
                    <select id="create-grade" value={grade} onChange={e => setGrade(e.target.value)} required>
                      <option value="">Select</option>
                      {[9, 10, 11, 12].map(g => <option key={g} value={g}>Grade {g}</option>)}
                    </select>
                  </div>
                  <div className="add-student-modal__field">
                    <label htmlFor="create-year">Graduation Year</label>
                    <input id="create-year" type="number" value={graduationYear} onChange={e => setGraduationYear(e.target.value)} placeholder="2028" />
                  </div>
                </div>
                <div className="add-student-modal__field">
                  <label htmlFor="create-school">School</label>
                  <input id="create-school" type="text" value={school} onChange={e => setSchool(e.target.value)} placeholder="School name" />
                </div>
                <button type="submit" className="add-student-modal__submit" disabled={!firstName || !lastName || !email || busy}>
                  {busy ? 'Sending…' : 'Send Invite'}
                </button>
              </form>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default AddStudentModal;
